// extracted by mini-css-extract-plugin
export default {"LightButton":"LightButton__LightButton__HKV11"};